export default __webpack_public_path__ + "f732436a5271d2c5f0198eeec851ecb0.svg";